// extracted by mini-css-extract-plugin
module.exports = {"base":"Accordion_base__IbqyU","container":"Accordion_container__dA5v0"};